import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  class: "filter-bar-row"
};
const _hoisted_2 = {
  key: 0,
  class: "filter-bar-actions"
};
const _hoisted_3 = {
  key: 0,
  class: "mt-3 flex flex-wrap items-center justify-end gap-2"
};
const _hoisted_4 = {
  key: 1,
  class: "mt-3"
};
import { computed } from 'vue';
export default {
  __name: 'CompactFilterBar',
  props: {
    shellClass: {
      type: String,
      default: 'filter-bar-shell is-compact'
    },
    bodyClass: {
      type: String,
      default: 'filter-bar-body is-compact'
    },
    contentClass: {
      type: String,
      default: 'filter-bar-content'
    }
  },
  setup(__props) {
    const props = __props;
    const shellClass = computed(() => props.shellClass);
    const bodyClass = computed(() => props.bodyClass);
    const contentClass = computed(() => props.contentClass);
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(shellClass.value)
      }, [_createElementVNode("div", {
        class: _normalizeClass(bodyClass.value)
      }, [_createElementVNode("div", {
        class: _normalizeClass(contentClass.value)
      }, [_createElementVNode("div", _hoisted_1, [_renderSlot(_ctx.$slots, "default")]), _ctx.$slots.actions ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_renderSlot(_ctx.$slots, "actions")])) : _createCommentVNode("", true)], 2), _ctx.$slots.searchActions ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_renderSlot(_ctx.$slots, "searchActions")])) : _createCommentVNode("", true), _ctx.$slots.extra ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_renderSlot(_ctx.$slots, "extra")])) : _createCommentVNode("", true)], 2)], 2);
    };
  }
};